// ==========================================================================
// Accordion Module
// ==========================================================================

export default class Accordion {
	constructor(accordionElement) {
		this.accordion = accordionElement;
		this.items = this.accordion.querySelectorAll('.accordion__item');

		this.init();
	}

	init() {
		this.items.forEach(item => {
			const header = item.querySelector('.accordion__header');
			const content = item.querySelector('.accordion__content');

			if (header && content) {
				header.addEventListener('click', () => {
					this.toggle(item, content);
				});
			}
		});
	}

	toggle(item, content) {
		const isActive = item.classList.contains('is-active');

		if (isActive) {
			item.classList.remove('is-active');
			content.style.maxHeight = null;
		} else {
			// Close other items (optional)
			this.items.forEach(otherItem => {
				if (otherItem !== item && otherItem.classList.contains('is-active')) {
					otherItem.classList.remove('is-active');
					const otherContent = otherItem.querySelector('.accordion__content');
					if (otherContent) {
						otherContent.style.maxHeight = null;
					}
				}
			});

			item.classList.add('is-active');
			content.style.maxHeight = content.scrollHeight + 'px';
		}
	}
}

// Initialize all accordions
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.accordion').forEach(accordion => {
		new Accordion(accordion);
	});
});
